<!--
/*******************************************************************************
*@ 컴포넌트명   : CorporationInfo0.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 조회 [기업]
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="corporation">
    <div class="scroll">
      <contents-header :bg-type="true" title="MCOP-01-01-02-01" description="MCOP-01-01-02-02" />
      <article class="contents">
        <div class="form">
          <!-- 기업명 -->
          <div class="form-row">
            <input-text
              ref="ovsesCustOcntryName"
              id="ovsesCustOcntryName"
              :value="RBF0409E40.ovsesCustOcntryName"
              disabled
              label-i18n="MCOP-01-01-02-03"
            />
          </div>
          <!-- 회사 전화번호 -->
          <div class="form-row">
            <input-text
              ref="coTelno"
              id="coTelno"
              :value="RBF0409E40.coTelno"
              disabled
              label-i18n="MCOP-01-01-02-04"
            />
          </div>
          <!-- 팩스번호 -->
          <div class="form-row">
            <input-text
              ref="faxNo"
              id="faxNo"
              :value="RBF0409E40.faxNo"
              disabled
              label-i18n="MCOP-01-01-02-05"
            />
          </div>
          <!-- 법인소재지주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*법인소재지주소*/ $t("MCOP-01-01-02-06") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40.coprNmad"
                ref="coprNmad"
                id="coprNmad"
                :value="RBF0409E40.coprNmad"
                disabled
              />
              <input-text ref="coprAddr1" id="coprAddr1" :value="RBF0409E40.coprAddr1" disabled />
              <input-text
                v-if="RBF0409E40.coprAddr2"
                ref="coprAddr2"
                id="coprAddr2"
                :value="RBF0409E40.coprAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40.coprAddr3"
                ref="coprAddr3"
                id="coprAddr3"
                :value="RBF0409E40.coprAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 대표자명 -->
          <div class="form-row">
            <input-text
              ref="rprsOcntryName"
              id="rprsOcntryName"
              :value="RBF0409E40.rprsOcntryName"
              disabled
              label-i18n="MCOP-01-01-02-07"
            />
          </div>
          <!-- 대표자 휴대폰번호 -->
          <div class="form-row">
            <input-text
              ref="cphnNo"
              id="cphnNo"
              :value="RBF0409E40.cphnNo"
              disabled
              label-i18n="MCOP-01-01-02-08"
            />
          </div>
          <!-- 내선번호 -->
          <div class="form-row">
            <input-text
              ref="exno"
              id="exno"
              :value="RBF0409E40.exno"
              disabled
              label-i18n="MCOP-01-01-02-09"
            />
          </div>
          <!-- 이메일 주소 -->
          <div class="form-row">
            <input-text
              ref="rprsEmad1"
              id="rprsEmad1"
              :value="RBF0409E40.rprsEmad1"
              disabled
              label-i18n="MCOP-01-01-02-10"
            />
          </div>
          <!-- 대표자 주소 -->
          <div class="form-row">
            <div class="item-tit">{{ /*대표자 주소*/ $t("MCOP-01-01-02-11") }}</div>
            <div class="item-desc">
              <input-text
                v-if="RBF0409E40.rprsNmad"
                ref="rprsNmad"
                id="rprsNmad"
                :value="RBF0409E40.rprsNmad"
                disabled
              />
              <input-text ref="rprsAddr1" id="rprsAddr1" :value="RBF0409E40.rprsAddr1" disabled />
              <input-text
                v-if="RBF0409E40.rprsAddr2"
                ref="rprsAddr2"
                id="rprsAddr2"
                :value="RBF0409E40.rprsAddr2"
                disabled
              />
              <input-text
                v-if="RBF0409E40.rprsAddr3"
                ref="rprsAddr3"
                id="rprsAddr3"
                :value="RBF0409E40.rprsAddr3"
                disabled
              />
            </div>
          </div>
          <!-- 우편물 수신 -->
          <div class="form-row">
            <input-text
              ref="postSendAreaDstcd"
              id="postSendAreaDstcd"
              :value="$te(RBF0409E40.postSendAreaDstcd+'_우편발송지구분코드')?$t(RBF0409E40.postSendAreaDstcd+'_우편발송지구분코드'):''"
              disabled
              label-i18n="MCOP-01-01-02-12"
            />
          </div>
          <!-- 거래 Statement 우편발송 여부 -->
          <div v-if="siteCode===$config.SITECODE_OGAUC" class="form-row">
            <input-text
              ref="postSendYn"
              id="postSendYn"
              :value="$te(RBF0409E40.postSendYn+'_우편발송여부')?$t(RBF0409E40.postSendYn+'_우편발송여부'):''"
              disabled
              label-i18n="MCOP-01-01-02-14"
            />
          </div>
        </div>
        <div
          v-if="siteCode===$config.SITECODE_OGAUC"
          class="info info-etc"
        >※ {{ /*조회 > 거래내역조회 > Statement조회 에서 조회 후 인쇄할 수 있습니다.*/ $t("MCOP-01-01-02-16") }}</div>
      </article>
    </div>
    <div class="btn-area--full fixed">
      <button class="btn md gray" @click="goPrevStep">{{ /*뒤로*/ $t("MCOM-0000078") }}</button>
      <button
        v-if="isCorporationMasterUser"
        class="btn md normal"
        @click="goNextStep"
      >{{ /*수정*/ $t("MCOP-01-01-02-18") }}</button>
    </div>
  </section>
</template>
<script>
import Common from "@/components/basic/Common";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

export default {
  extends: Common,
  computed: {
    ...mapFields("admin/personalInfo", ["RBF0409E40", "RBF0409E40_data"]),
    ...mapGetters(["isCorporationMasterUser"]),
  },
  data() {
    return {};
  },
  mounted() {
    this.RBF0409E40_data = {};
    this.RBF0409E40Call();
  },
  methods: {
    RBF0409E40Call() {
      this.$post("/customer/cust/CustInfoInq", {}, this.RBF0409E40Suc);
    },
    RBF0409E40Suc(res) {
      this.RBF0409E40 = res.outItem;

      if (!this._.isNil(res.outItem.rprsEmad1)) {
        const email = res.outItem.rprsEmad1.split("@");
        this.RBF0409E40.rprsEmailId = email[0];
        this.RBF0409E40.rprsEmailAddress = email[1];
      }
    },
    goPrevStep() {
      this.$router.push({ name: "perInfoAuthenticationCorp" });
    },
    goNextStep() {
      this.$router.push({ name: "perInfoStep1Corp" });
    },
  },
};
</script>